import React, { useEffect } from "react";
import { getBrowserInfo, getDeviceName, getVisitorId } from "./trackUtils";
import { web_analytics_end_session, web_analytics_start_session } from "../store/api";


const SessionTracker = ({ apiresponse,trackState,collectionURL }) => {
  const ANALYTICS_ROOT_PATH = process.env.REACT_APP_API_ANALYTICS_ROOT_PATH;
  const idleLimit = 15 * 60 * 1000; // 15 minutes
  let sessionStartTime = Date.now();
  let lastActivityTime = sessionStartTime;
  let idleTime = 0;

  const sendSessionData = async (endTime, visitorId) => {
    const data = {
      session_id: trackState.sessionId,
      visitor_id: trackState.visitorId,
      // start_time: sessionStartTime,
      // end_time: endTime || Date.now(),
      view_type: trackState.campaignData.qrscan !=null ? "qr"  :  "link", // or 'qr' based on your needs
      browser: getBrowserInfo(),
      device_name: getDeviceName(),
      page_url: window.location.href,
      cid: apiresponse?.uid,
      page_id: collectionURL,
      micropage_id: apiresponse?.collectionID,
      micropage_name: apiresponse?.branding?.collectionTitle,
      micropage_type: "Collections",
      campaign_id: apiresponse?.campaign_id,
      campaign_name: apiresponse?.campaign_id,
      latitude: trackState.geoLocation.latitude, // Replace with dynamic values if necessary
      longitude: trackState.geoLocation.longitude,
      country: trackState.geoLocation.country,
      city: trackState.geoLocation.city,
      eic:trackState.campaignData.eic
    };
    
    
    console.log(data)

    try {
      const response = await web_analytics_start_session(data);
      console.log("Session data sent:", response);
    } catch (error) {
      console.error("Error sending session data:", error);
    }
  };


  const endSessionData = async (endTime) => {
    const data = {
      session_id: trackState.sessionId,
      visitor_id: trackState.visitorId,
      cid: apiresponse?.uid,
      end_time: endTime || Date.now(),
      api_key: "c3FP7iX{3]j9",
      allowed_domain: "http://localhost:3000"
    };
  
    console.log("Sending end session data:", data);
    const response = await web_analytics_start_session(data);
    // Use sendBeacon for synchronous data sending during `beforeunload`
    const url = ANALYTICS_ROOT_PATH+"end_session"; // Replace with your API endpoint
    const blob = new Blob([JSON.stringify(data)], { type: "application/json" });
    const res = navigator.sendBeacon(url, data)
    console.log(res,"ressss");
    if (!navigator.sendBeacon(url, data)) {
      console.error("Failed to send session end data using sendBeacon.");
    }
  };

  const resetIdleTime = () => {
    idleTime = 0;
    lastActivityTime = Date.now();
  };

  const trackIdleTime = () => {
    idleTime += 1000;
    if (idleTime >= idleLimit) {
      console.log("User idle timeout reached");
      sendSessionData();
      idleTime = 0; // Reset idle time after sending data
    }
  };

  useEffect(() => {
    let visitorId = null;

    const initialize = async () => {
      visitorId = await getVisitorId();
      if (apiresponse?.status === "success" && trackState.sessionId) {
        sendSessionData(null, visitorId); // Send initial session data
      }
    };

    initialize();

    // Monitor user activity
    const events = ["mousemove", "keydown", "click", "scroll"];
    events.forEach((event) => document.addEventListener(event, resetIdleTime));

    // Track idle time
    const idleInterval = setInterval(trackIdleTime, 1000);

    // Send session data when the tab or browser is closed
    const handleBeforeUnload = () => {
      if (apiresponse?.status === "success") {
        endSessionData(Date.now());
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup event listeners on component unmount
    return () => {
      events.forEach((event) =>
        document.removeEventListener(event, resetIdleTime)
      );
      clearInterval(idleInterval);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [apiresponse,trackState]);

  return null;
};

export default SessionTracker;
